<template>
  <div class="page-wrap">
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
  </div>
</template>

<script>
import store from '@app/store';
import helper from '@app/services/helper';

const dataSideTree = [
  { title: 'Основная', name: 'personal-area.main' },
  { title: 'Клиника', name: 'personal-area.clinic', roles: ['orgadmin'] },
  { title: 'Личная информация', name: 'personal-area.personal' },
  { title: 'Модули', name: 'personal-area.modules', roles: ['orgadmin'] },
  {
    title: 'Регистратура',
    name: 'registry',
    roles: ['orgadmin'],
    children: [
      { title: 'Описание', name: 'registry.main' },
      { title: 'Департаменты', name: 'registry.departments' },
      { title: 'Специальности', name: 'registry.specialties' },
      { title: 'Сотрудники', name: 'registry.employees' },
      { title: 'Доктора', name: 'registry.doctors' },
      { title: 'Расписание', name: 'registry.schedule' },
      { title: 'Реестр пациентов', name: 'registry.patients'}
    ]
  },
  {
    title: 'Прием пациентов',
    name: 'reception',
    roles: ['orgadmin', 'doctor']
  },
  {
    title: 'Запись к врачу',
    name: 'appointment',
    roles: ['patient'],
    children: [
      { title: 'Записаться', name: 'appointment.make' },
      { title: 'Мои записи', name: 'appointment.myrecords'},
      { title: 'История', name: 'appointment.history' }
    ]
  },
  { title: 'Назад', name: 'clinic.public' }
];

export default {
  methods: {
    filterTree(tree, roles) {
      return tree.reduce((acc, node) => {
        if (
          typeof node.roles === 'undefined' ||
          node.roles.findIndex(role => roles.indexOf(role) > -1) > -1
        ) {
          if (typeof node.children === 'undefined') {
            acc.push(node);
          } else {
            const children = this.filterTree(node.children);
            acc.push({ ...node, children });
          }
        }
        return acc;
      }, []);
    }
  },
  async beforeRouteEnter({ name }, from, next) {
    await store.dispatch('clinic/preload', name);
    const uuid = store.state.clinic.id;
    const { resources } = store.state.permission;
    const roles =
      typeof resources.organization === 'undefined' ||
      typeof resources.organization[uuid] === 'undefined'
        ? []
        : resources.organization[uuid].roles;
    const sideTree = helper.filterTree(dataSideTree, roles);
    store.commit('navigation/setSideTree', sideTree);
    next();
  },
  async beforeRouteUpdate({ name }, from, next) {
    await store.dispatch('clinic/preload', name);
    next();
  },
  beforeRouteLeave(to, from, next) {
    store.commit('navigation/setSideTree', []);
    next();
  }
};
</script>

<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 200ms ease;
}
.fade-leave-active {
  transition: opacity 200ms ease;
  opacity: 0;
}
.page-wrap {
  width: 100%;
  max-width: 1200px;
  padding: 2rem 0;
  margin: auto;
}
</style>
